var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinearIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "measure-line_svgrepo.com",
    clipPath: "url(#clip0_577_6089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33301 26.6663H30.6663V15.9997H1.33301V26.6663ZM2.66634 17.333H29.333V25.333H27.9997V21.333H26.6663V25.333H25.333V22.6663H23.9997V25.333H22.6663V18.6663H21.333V25.333H19.9997V22.6663H18.6663V25.333H17.333V21.333H15.9997V25.333H14.6663V22.6663H13.333V25.333H11.9997V18.6663H10.6663V25.333H9.33301V22.6663H7.99967V25.333H6.66634V21.333H5.33301V25.333H2.66634V17.333ZM26.6663 5.33301V6.66634H5.33301V5.33301H1.33301V9.33301H5.33301V7.99967H26.6663V9.33301H30.6663V5.33301H26.6663ZM3.99967 7.99967H2.66634V6.66634H3.99967V7.99967ZM29.333 7.99967H27.9997V6.66634H29.333V7.99967Z",
    fill: "#20C3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_6089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearIcon);
export default __webpack_public_path__ + "static/media/linearIcon.38bd71899acead22fc2de53cd4bf7d85.svg";
export { ForwardRef as ReactComponent };